import e from"styled-components";import{theme as i}from"../../../../theme.js";const o=e.div`
  padding: ${i.spacing*8}px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  background-color: ${i.colors.primary[500]};
  height: 100%;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 800px;
  > h3, > h1 {
    margin: 0;
    color: ${i.colors.shades[0]};
    text-align: center;
  }
  @media screen and (max-width: ${i.breakpoints.md}) {
    width: 100%;
  }
`,n=e.div`
  padding: ${i.spacing*6}px ${i.spacing*12}px;
  background-color: ${i.colors.shades[0]};
  border-radius: 100px;
  display: flex;
  gap: ${i.spacing*2}px;
  align-items: center;
  flex-direction: column;
  margin-top: ${i.spacing*12}px;
  > h4, > h3 {
    margin: 0;
    color: ${i.colors.gray[900]};
  }
`;export{o as Container,n as ReviewValueContainer};
